import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Button, makeStyles } from '@material-ui/core'
import ChatDisclaimerIcon from 'components/RightPane/ChatDisclaimerIcon'
import useBetaWorkspaceToggle from 'pages/ProjectsPage/WorkspacePage/components/WorkspaceRightPane/hooks/useBetaWorkspaceToggle'
import React from 'react'
import { chatPrimaryColor, chatTextColor } from './colors'
import { useChatBot } from './useChatBotHook'

export interface ChatDisclaimerStylesProps {
    isBetaWorkspaceToggleEnabled?: boolean
}

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(1.25),
        paddingRight: theme.spacing(1.25),
        gap: '20px',
    },
    disclaimerText: (props: ChatDisclaimerStylesProps) => ({
        fontSize: pxToRem(14),
        fontWeight: 400,
        fontFamily: props.isBetaWorkspaceToggleEnabled ? 'Lexend' : 'Roboto',
        lineHeight: pxToRem(21),
        color: chatTextColor,
    }),
    okButton: (props: ChatDisclaimerStylesProps) => ({
        color: props.isBetaWorkspaceToggleEnabled
            ? 'none !important'
            : chatPrimaryColor,
        borderRadius: '100px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: props.isBetaWorkspaceToggleEnabled
            ? 'none !important'
            : chatPrimaryColor,
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(0),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        fontSize: pxToRem(16),
        fontWeight: 500,
        fontFamily: props.isBetaWorkspaceToggleEnabled ? 'Lexend' : 'Roboto',
        lineHeight: pxToRem(32),
    }),
}))

export const ChatDisclaimerMessage: string =
    'Dela is generated by an artificial intelligence tool. It is provided subject to the Specpoint Product terms, and Deltek does not independently verify the accuracy of each Dela chat. Users should independently review and verify the accuracy of the Dela chat.'

const ChatDisclaimer = () => {
    const isBetaWorkspaceToggleEnabled = useBetaWorkspaceToggle()
    const classes = useStyles({ isBetaWorkspaceToggleEnabled })
    const { setIsDisclaimerOpen } = useChatBot()

    const hideDisclaimer = () => {
        setIsDisclaimerOpen(false)
    }

    return (
        <div className={classes.container}>
            <ChatDisclaimerIcon />
            <p className={classes.disclaimerText} data-testid="disclaimerText">
                {ChatDisclaimerMessage}
            </p>
            <Button
                id="hideDisclaimerButton"
                data-testid="hideDisclaimerButton"
                type="button"
                aria-label="OK"
                role="button"
                color="primary"
                variant="outlined"
                size="large"
                className={classes.okButton}
                onClick={hideDisclaimer}
            >
                OK
            </Button>
        </div>
    )
}

export default ChatDisclaimer
